//默认会去读缓存，防止刷新丢失
var user = {
    phone: '',
    name: '',
    icon: ''
};
try {
    var storageUser = window.localStorage.user && JSON.parse(window.localStorage.user);
    user = storageUser || user;
} catch (err) {
    console.log(err);
}


export default {
    //用户信息
    user: user,
    defaultIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAADd0lEQVRIS6VXS04bQRCtGhnJeAPeIE3PAjgB5gTACUJOEHKCwAmCT4A5QcwJcE6AOQFwgsDCPRIbsxqQQFT0WtVWe+j5hPTGkmemPq/qvapmankeHx8Hb29v34hoICLrzDzQT6f6e9vpdC42NjZu25jkppdms9kpEf1g5nV995qInkTEOWDmff1/T3/viWhkjDmvs13p2Fp7SERnRLRFRHA2Wl1dnfb7/aeYwfl8vv7y8nIoIkdEhCAQwIkxZhJ7P+oYWTLzTzhk5tM0TT2cTQC553me77+/v4+YeUe/H5Y//ODYWjsmItTywhiD6D99vC0RGWdZ9j00tOTYZ8rM39M0RQD/fbxNERlmWYZ+cWfhWGt62SZTrecODHS73buqunsnAYpffc2dYxh6fn6+IaIHY4zv0g/Z5nm+JSJoODTe4gDKJEmGaZqioaJnNpvdMvOaMWZ7kXEA8UFVI4HHr6+vV8yMYMfM7OgkIuDzkYjIysrKQRWP0XAicqWdPnIZW2tBkakxZikTHzoQKYriDxBJkuSwnJmKy0RE1nq93nYV9NZasGMTWbN+BJgX+JexstaOICKdTme3KaNyE4W28jwHMr9gh71RY0ydmKB293X1V+SmyDrLst1YobWX5kR0DsdOHOqMWmtRwiU6xAy3TML5Y+02ZBOtb9ADkyZBsdZCHgfGGMhs9PhEkXFjNmpwx1OhBkb0yl1dEgsGtXQMNC7r4PYwM3MlJRHwwrFCfdsCRq/hmFJDTxml2hkzQ9cb9T2EurG5AulDDb+ocECJMKN9PX/XQextaKJPreikqoMx6eX0Qect7MHxphqeMjOkMzpGl+hUJyD6IhweQ7UwW7vd7qSsTKrh6AO8hyCwgZxEhMj1ihOQgC43xpiDkkxCm7FjNXI4gNItEViNykKi9d0C3Zzj2JBQCqGelVJaxVUvjeECEB0SmvW9iMwRpbUWkKFTP70QhDZQnqIogF7fi8uHRQBRYt4y83WbLq3KWpPBxMLiN1G6LS8C5fo4LWXerhvsdQ79swBezO346hNw1QlFbEFr46zUnJXCUrveojOTJDn55HoLp5WMaFrosQCAl5izo16vd1230BdFscfMaEwIDUTm+J8W+hBSpRqMrXl1whWmtHNBOkNVg4Ag6MrTeHfyX6rCYRD4y5q/K+F6g4NL27jtpe0vCh9ex0pxklAAAAAASUVORK5CYII=',
    //登录窗口状态
    loginDialog: false,
    //性别选择窗口
    sexDialog: false,
    //是否为新注册用户
    isNewCommer: false,
    //登录状态
    loginStep: '',
    // 在线反馈窗口
    feedbackVisible: false,
    // 检测状态(0: 未检测，1：正在检测)
    checkStatus: 0
};



// WEBPACK FOOTER //
// ./app/store/state.js